import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.5 5.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5zm0 18c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5zM4 16c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5m19.5-1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5zM7.516 7.516a1.5 1.5 0 0 0 0 2.123l2.123 2.124a1.502 1.502 0 0 0 2.124-2.124L9.634 7.516a1.497 1.497 0 0 0-2.118 0m14.85 12.726a1.502 1.502 0 0 0-2.124 2.124l2.124 2.118a1.502 1.502 0 0 0 2.123-2.123l-2.123-2.123zm-14.85 4.242a1.5 1.5 0 0 0 2.123 0l2.124-2.123a1.502 1.502 0 0 0-2.124-2.123l-2.123 2.128a1.5 1.5 0 0 0 0 2.123zm12.726-14.85a1.502 1.502 0 0 0 2.124 2.124l2.118-2.124a1.502 1.502 0 0 0-2.123-2.123l-2.123 2.123z"
    }, null, -1)
  ]))]))
}
export default { render: render }